import React from "react";
import SubheaderBase from "./subheader-base";
import { useSubheaderData } from "../../../hooks/useSubheaderData";

type Props = {
  subheaders?: string[];
};

const Subheader: React.FC<Props> = ({ subheaders }) => {
  const { hiddenSubheaders, toggleHidden } = useSubheaderData();

  return (
    <SubheaderBase
      subheaders={subheaders}
      hiddenSubheaders={hiddenSubheaders}
      onToggleHidden={toggleHidden}
    />
  );
};
export default Subheader;
